import { Injectable } from '@angular/core';
import { HttpDataService } from '../../../shared/http/http-data.service';


export interface ICatalogSelectionRequest {
  countryId: number;
  companyCountryId: number;
  oemId: number;
  includeInWebshopCatalog: boolean;
  categorySelection: {
    wildcard: boolean;
    categories: string[]
  };
}

@Injectable()
export class WebshopCatalogSelectionDataService {
  constructor(
    private httpDataService: HttpDataService
  ) {
    /**/
  }

  public saveCategoriesSelection(webshopId: number, data: ICatalogSelectionRequest): Promise<void> {
    return this.httpDataService.doPOST(
      `rest/webshops/${webshopId}/catalogselection`,
      undefined,
      data,
      undefined,
      'Error saving categories selection'
    );
  }
}